/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './Vote.css';
import WhereField from './partials/WhereField';
import LeaderboardStats from './partials/LeaderboardStats';
import RegisterForm from './partials/RegisterForm';
import {
  login,
  register,
  fetchUser,
} from '../actions';


class Vote extends OzComponent {

  static need = [
    ['user', fetchUser],
  ]

  state = {};

  componentDidMount() {
    try {
      scroll(0, 0);
    } catch (e) {
    }
  }

  register(e, values) {
    e.preventDefault();
    this.props.register(values)
      .then(resp => {
        if (!resp.error) {
          return this.props.login({
            username: values.username,
            password: values.password,
          });
        }
      })
      .then(resp => {
        if (!resp.error) {
          setToken(resp.token);
          this.props.fetchUser()
            .then(resp => {
              console.log('registered!');
              navTo('/p/' + values.username + '?tehelp=1');
            });
        }
      });
  }

  renderSpreadsheetBlurb() {
    return (
      <div className="spreadsheet-blurb">
        <div className="header">Have a spreadsheet? (BETA)</div>
        <p><b>Do you track your escapes in a spreadsheet?</b> You can import it into EscapeSpy! Use our tool to easily track dozens or hundreds of escapes that you already have in a spreadsheet.</p>
        <Link to="/sh"><Button bsSize="lg">Import Your Spreadsheet</Button></Link>
      </div>
    )
  }

  renderBlurbForm() {
    let user = this.props.user;
    let isLoggedIn = user && user.profile;

    return (
      <div className="blurb-and-form">
        <div className="blurb">
          <div className="blurb-copy">
            <p className="top-line">Rank escape rooms and determine EscapeSpy's <b>Best Room Awards</b> for 2019</p>
            <p><b>Some escape rooms are great, and some are amazing.</b> We want to reward the very best escape rooms, and give recognition to the designers and creators who go the extra mile to make immersive and unique escape experiences.</p>
            <p><b>Do you have favorite rooms that you think should be recognized?</b> Vote for your top rooms and help them win awards. The top rated rooms will be highlighted on the site to make it easier for players to find and experience these great rooms.</p>
            <p><h2>How it works:</h2> Voting is open until <b>January 15th</b>. All ratings submitted on or before that date will be included, and we'll combine all the votes to rank the best rooms across the site, and in each major city. We'll also give out special recognition awards for categories like most immersive and best puzzles.</p>
            <p><b>To cast your votes</b> just follow these three steps:</p>
            <ol>
              <li>
                <div className="big"><b>Create a profile</b></div>
                <div className="small">All your votes will be associated with your EscapeSpy profile.</div>
              </li>

              <li>
                <div className="big"><b>List your escapes</b></div>
                <div className="small">Add all the rooms you've done and want to rate for the awards.</div>
              </li>

              <li>
                <div className="big"><b>Add ratings</b></div>
                <div className="small">Rate and review each room based on your experience.</div>
              </li>
            </ol>

            <div className="phone-form">{this.renderForm()}</div>

            <h2>Questions:</h2>
            <p><h3>Can I vote if I'm an owner/employee?</h3></p>
            <p>Yes, but only for other rooms. Please don't vote for your own rooms, or those of your employer.</p>
            <p>We reserve the right to remove suspicious reviews and/or verify their authenticity.</p>
            <p><h3>How are awards determined?</h3></p>
            <p>We'll combine all the ratings and rank the rooms. We'll apply weighting and normalize the ratings, to account for the fact that people have different interpretations of our 1-100 rating scale.</p>

            <p><h3>Should I add all the rooms I've done?</h3></p>
            <p>Yes. Additional weight will be given to people who rate lots of rooms. It means more if you have a #1 room after doing 100+ rooms, so add as many as you can, even if they're not all amazing.</p>
          </div>
        </div>
        <div className="desktop-form">{this.renderForm()}</div>
      </div>
    )
  }

  renderForm() {
    let user = this.props.user;
    let isLoggedIn = user && user.profile;

    return (
      <div className="form">
        <div className="form-title">
          <div className="form-icon"><img src="https://escapespy.s3-us-west-2.amazonaws.com/misc/awards/006-star.svg" /></div>
          <div className="form-title-copy">
            Vote for the EscapeSpy awards
          </div>
        </div>

        {!isLoggedIn && <RegisterForm
         values={{}}
         errors={this.props.errors.register}
         buttonText="Sign Up and Vote"
         onSubmit={(e, values) => this.register(e, values)}
         />}
        {isLoggedIn && <div className="go-to-profile">
         <p>Go to you profile to vote for best rooms</p>
         <Link to={'/p/' + user.profile.username}><Button bsSize="lg" bsStyle="primary">Go To Profile</Button></Link>
         </div>}
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="Vote">
        <div className="title">
          <div className="icon"><img src="https://escapespy.s3-us-west-2.amazonaws.com/misc/awards/006-star.svg" /></div>
          <div className="top-title">EscapeSpy Room Awards</div>
          <div className="main-title">Best Rooms of 2019</div>
        </div>
        {this.renderBlurbForm()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    login,
    register,
    fetchUser,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Vote);



/** WEBPACK FOOTER **
 ** ./src/components/Vote.js
 **/